/**
 * Buff Beauty: ingredients list modal (product page).
 * Opens via .js-ingredient-modal-open; closes on overlay, close button, or Escape.
 */
(function () {
  'use strict';

  const OPEN_CLASS = 'is-open';
  const BODY_LOCK_CLASS = 'ingredient-modal-open';

  function getModal() {
    return document.querySelector('.ingredient-modal');
  }

  function openModal(trigger) {
    const modal = getModal();
    if (!modal) return;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add(OPEN_CLASS);
    document.body.classList.add(BODY_LOCK_CLASS);

    if (trigger) {
      modal._buffIngredientTrigger = trigger;
    }

    const dialog = modal.querySelector('.ingredient-modal__dialog');
    const closeBtn = modal.querySelector('.ingredient-modal__close');
    (closeBtn || dialog)?.focus();
  }

  function closeModal() {
    const modal = getModal();
    if (!modal || !modal.classList.contains(OPEN_CLASS)) return;

    modal.classList.remove(OPEN_CLASS);
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.body.classList.remove(BODY_LOCK_CLASS);

    const trigger = modal._buffIngredientTrigger;
    modal._buffIngredientTrigger = null;

    if (trigger && typeof trigger.focus === 'function') {
      trigger.focus();
    }
  }

  function onDocumentClick(event) {
    const openBtn = event.target.closest('.js-ingredient-modal-open');
    if (openBtn) {
      event.preventDefault();
      openModal(openBtn);
      return;
    }

    if (event.target.closest('.js-ingredient-modal-close')) {
      event.preventDefault();
      closeModal();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onKeydown);
})();
